export const API_URL = process.env.REACT_APP_REST_API_HOST;
export const REACT_URL = process.env.REACT_APP_PUBLIC_URL;
export const requiredRules = [{ required: true, message: "Required" }];
export const JWT_TOKEN = "dban-jwt-token";
export const formItemLayout = {
  labelCol: { xs: 24, sm: 24, md: 10, lg: 8, xl: 8 },
  wrapperCol: { xs: 24, sm: 24, md: 14, lg: 16, xl: 16 },
  labelAlign: "left",
};
export const formItemProps = {
  wrapperCol: { xs: 24 },
  labelCol: { xs: 24 },
  labelAlign: "left",
  className: "mb-md-3 mb-1",
};

export const monthOptions = [
  {
    label: "Baisakh",
    value: "Baisakh",
  },
  {
    label: "Jestha",
    value: "Jestha",
  },
  {
    label: "Ashadh",
    value: "Ashadh",
  },
  {
    label: "Shrawan",
    value: "Shrawan",
  },
  {
    label: "Bhadra",
    value: "Bhadra",
  },
  {
    label: "Ashwin",
    value: "Ashwin",
  },
  {
    label: "Kartik",
    value: "Kartik",
  },
  {
    label: "Mangsir",
    value: "Mangsir",
  },
  {
    label: "Poush",
    value: "Poush",
  },
  {
    label: "Magh",
    value: "Magh",
  },
  {
    label: "Falgun",
    value: "Falgun",
  },
  {
    label: "Chaitra",
    value: "Chaitra",
  },
];

export const weekOptions = [
  {
    label: "First Week",
    value: "First Week",
  },
  {
    label: "Second Week",
    value: "Second Week",
  },
  {
    label: "Third Week",
    value: "Third Week",
  },
  {
    label: "Fourth Week",
    value: "Fourth Week",
  },
];

export const financeHighlightedHeadings = [
  "Liabilities",
  "Assets",
  "Expenses",
  "Income",
  "Total Liabilities",
  "Total Assets",
  "Total Expenses",
  "Total Income",
];

export const noAmtHeadings = [
  'Liabilities',
  'Assets',
  'Expenses',
  'Income'
]
export const COLORS = [
  "#0088FE", // Blue
  "#00C49F", // Teal
  "#FFBB28", // Yellow
  "#FF8042", // Orange
  "#A28FD0", // Purple
  "#FF6666", // Light Red
  "#66CC99", // Mint
  "#FFCC00", // Bright Yellow
  "#3399FF", // Sky Blue
  "#FF99CC", // Pink
  "#9966CC", // Lavender
  "#66CCCC", // Aqua
  "#FF9966", // Peach
  "#6699CC", // Soft Blue
  "#99CC66", // Lime Green
];
